import { ACTION_TYPES } from "src/constants";
import { INITIAL_STATE } from "../store";

export default function MessageTemplateVariablesReducer(state = INITIAL_STATE.messageTemplateVariables, action){
  switch (action.type) {

    case ACTION_TYPES.REQUEST_MESSAGE_TEMPLATES_SUCCESS: {
      return action.payload.templateVariables
    }

    case ACTION_TYPES.REQUEST_ADMIN_LOGOUT:
    case ACTION_TYPES.ADMIN_LOGOUT_SUCCESS:
      return INITIAL_STATE.messageTemplateVariables;

    default:
      return state;
  }
}